{
  "WHATSAPP_TEMPLATE_MGMT": {
    "TITLE": "Skabeloner",
    "DESCRIPTION": "Se de beskedskabeloner, der synkroniseres fra dine WhatsApp-indbakker. Skabeloner oprettes og redigeres hos din udbyder.",
    "COUNT": "{n} skabelon | {n} skabeloner",
    "LEARN_MORE": "Læs mere om WhatsApp-skabeloner",
    "SYNC_TEMPLATES": "Synkroniser skabeloner",
    "SYNC_SUCCESS": "Synkronisering af skabeloner er startet for alle WhatsApp-indbakker. Det kan tage et par minutter, før opdateringerne vises.",
    "PARTIAL_SYNC_ERROR": "Synkronisering af skabeloner er startet for nogle WhatsApp-indbakker, men andre kunne ikke synkroniseres.",
    "SYNC_ERROR": "Kunne ikke starte synkronisering af skabeloner. Prøv igen.",
    "SEARCH_PLACEHOLDER": "Søg efter indhold eller navn...",
    "MANAGE_IN_META": "Administrer i Meta",
    "LOADING": "Indlæser WhatsApp-skabeloner...",
    "EMPTY": "Ingen WhatsApp-skabeloner fundet.",
    "NO_RESULTS": "Ingen skabeloner matcher dine filtre.",
    "FETCH_ERROR": "Kunne ikke indlæse WhatsApp-skabeloner. Prøv igen.",
    "PARTIAL_FETCH_ERROR": "Nogle WhatsApp-skabeloner kunne ikke indlæses. Prøv igen.",
    "LAST_SYNC_ATTEMPT": "Sidste synkroniseringsforsøg den {date}",
    "MORE_INBOXES": "+{n}",
    "STATUSES": {
      "UNSUBMITTED": "Ikke indsendt til godkendelse hos WhatsApp"
    },
    "FILTERS": {
      "ALL_INBOXES": "Alle indbakker",
      "ALL_LANGUAGES": "Alle sprog",
      "ALL_TYPES": "Alle typer"
    },
    "TYPES": {
      "TEXT": "Tekst",
      "IMAGE": "Billede",
      "VIDEO": "Video",
      "DOCUMENT": "Dokument",
      "CALL_TO_ACTION": "Handlingsopfordring",
      "COPY_CODE": "Kopier kode"
    },
    "PREVIEW": {
      "TITLE": "Forhåndsvisning af skabelon",
      "DESCRIPTION": "Se hvordan denne skabelon vises i WhatsApp.",
      "OPEN": "Forhåndsvis {name}",
      "CLOSE": "Luk forhåndsvisning",
      "DETAILS": "Skabelondetaljer",
      "STATUS": "Status",
      "TYPE": "Indholdstype",
      "CATEGORY": "Kategori",
      "LANGUAGE": "Sprog",
      "INBOXES": "Indbakker"
    }
  }
}
